export default __webpack_public_path__ + "static/media/kader.7f08d887.png";